module.exports = __webpack_public_path__ + "img/heroku-icon.30eb85e4.png";